var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button as MaterialButton } from '@mui/material';
import { styled } from '@mui/material/styles';
const StyledButton = styled(MaterialButton)(({ theme }) => ({
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.text.primary}`,
    backgroundColor: 'transparent',
    borderRadius: 4,
    fontSize: '.75rem',
    fontWeight: 500,
    cursor: 'pointer',
    '&:hover': {
        opacity: 0.7,
    },
}));
const Button = (_a) => {
    var _b;
    var { children } = _a, props = __rest(_a, ["children"]);
    props.variant = (_b = props.variant) !== null && _b !== void 0 ? _b : 'primary';
    return _jsx(StyledButton, Object.assign({}, props, { children: children }));
};
export default Button;
//# sourceMappingURL=Button.js.map